import type { Job } from '@core/types';
import type { JobData } from '@soVendor/types/optimization';

export function b2bJobToOptimizerJob(job: Job): JobData {
  const clientName = job.client?.name?.trim() || 'Client';
  return {
    title: job.title || 'Role',
    company: clientName,
    location: job.location || '',
    responsibilities: [],
    requirements: [],
    skills: job.skills_required ?? [],
    description: job.description || '',
    jobId: job.id,
  };
}
